import axios from "axios";

const getTopScanProduct = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/analytic/api/v1/dashboard/get-top-scan-products", {
        start_date: payload.start_date,
        end_date: payload.end_date,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
};

export default getTopScanProduct;
